export const CONTROLLER = '/admin/games/:gameId/controller'
export const PLAY_SELECT = `${CONTROLLER}/play-select`
export const STATS_UPDATE = `${CONTROLLER}/stats-update`
export const SCORE = `${CONTROLLER}/score`
export const POSSESSION = `${CONTROLLER}/possession`
export const PENALTY = `${CONTROLLER}/penalty`



// WEBPACK FOOTER //
// ./src/components/Controller/routes.js